// Must be first — installs Hermes-missing globals (DOMException) before any
// import that references them evaluates. See polyfills.ts (CORE-343).
import './polyfills';
import { registerRootComponent } from 'expo';
import "./public/global.css";
import { registerLiveKit } from './src/services/rtc/registerLiveKit';
import App from './App';

// CORE-393 — register LiveKit WebRTC globals on native (no-op on web). Must run
// before any LiveKit room connects.
registerLiveKit();

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
